module.exports = __webpack_public_path__ + "img/sunflower.57903276.jpeg";